/**
 * Combines date and time strings into an ISO datetime string, preserving user's timezone
 * @param date - Date string in YYYY-MM-DD format
 * @param time - Time string in HH:MM format (optional)
 * @returns ISO datetime string or just the date if no time provided
 */
export const combineDateAndTime = (date: string, time?: string): string => {
  if (time && date) {
    // Create a Date object in the user's local timezone (not UTC)
    // This ensures the date/time the user entered is interpreted in their timezone
    const localDateTime = new Date(`${date}T${time}`);
    return localDateTime.toISOString();
  } else {
    // Fallback to just date if no time provided
    return date;
  }
};